<template>
    <section class="flex-container my-4">
        <div class="flex gap-2 items-center">
            <label :for="selecionado.id">{{ descricao }}</label>
            <input type="checkbox" class="h-4 w-4 min-w-6 border-none border-preto-padrao cursor-pointer"
                :name="`chk-${selecionado.id}`" :id="selecionado.resposta"/>
        </div>
    </section>
</template>

<script>
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'Check',
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    setup(props) {
        const selecionado = ref({
            pergunta: props.descricao,
            resposta: false,
            id: props.identificador
        })
        return { selecionado }
    }
});
</script>